import { useContext } from 'react';
import { ClassContext } from 'edrolo/context';
import { Tooltip, Progress, enums } from 'edrolo-ui';
import { Lesson } from '../../../../../../../types/Assemblage';
import { useClassProgress } from 'edrolo/domains/bySchoolClass';

interface Props {
  lesson: Lesson;
}

export const TeacherProgressCircles = ({ lesson }: Props) => {
  const {
    data: { classId },
  } = useContext(ClassContext);

  const { data, loading, error } = useClassProgress(classId);

  if (loading || error) {
    return (
      <Tooltip
        tip={
          error
            ? 'There was an error loading progress data'
            : 'Loading progress data...'
        }
      >
        <Progress.Circles
          outerCircleProps={{
            numerator: 0,
            denominator: 0,
          }}
          innerCircleProps={{
            numerator: 0,
            denominator: 0,
          }}
        />
      </Tooltip>
    );
  }

  const nChunksViewed = Math.round(
    data.lessons[lesson.id]?.chunk_visit_count_avg || 0
  );

  if (!lesson.question_set) {
    return (
      <Tooltip
        tip={`Students have viewed an average of ${Math.round(
          nChunksViewed
        )} out of ${lesson.chunks.length} lesson parts`}
      >
        <Progress.Circle
          numerator={nChunksViewed}
          denominator={lesson.chunks.length}
          color={enums.ColorHue.BLUE}
          size={enums.Size.LARGE}
        />
      </Tooltip>
    );
  }

  const completedResponses = Math.round(
    data.exams[lesson.question_set.id]?.completed_responses_avg || 0
  );

  return (
    <Tooltip
      tip={`Students have viewed an average of ${nChunksViewed} out of ${lesson.chunks.length} lesson parts and completed an average of ${completedResponses} out of ${lesson.question_set.question_count} questions`}
    >
      <Progress.Circles
        outerCircleProps={{
          numerator: nChunksViewed,
          denominator: lesson.chunks.length,
          color: enums.ColorHue.BLUE,
        }}
        innerCircleProps={{
          numerator: completedResponses,
          denominator: lesson.question_set.question_count,
          color: enums.ColorHue.GREEN,
        }}
      />
    </Tooltip>
  );
};
